// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {useStore} from '@nanostores/react';
import {$user} from '../../../store/user.js';
import {Panel} from '../../../comp/panel';
import {Balance} from '../../../comp/balance';
import {User} from '../../../comp/user';
import {Redeem_details} from '../../../comp/redeem_details';
import * as cns from './status.module.less';

const NAME_ADAPT_OPTS = {
    hide_name: false,
};

export function Status(){
    const user = useStore($user);
    return <Panel className={cns.root}>
      <div className={cns.row}>
        <User className={cns.user} user={user} big no_bg
          name_placement="bottom" adaptive_opts={NAME_ADAPT_OPTS}/>
        <div className={cns.right}>
          <Balance has_withdraw/>
          <Redeem_details/>
        </div>
      </div>
    </Panel>;
}
